/**
 * Generated by orval v8.20.0 🍺
 * Do not edit manually.
 * Iaso
 * Iaso Swagger
 * OpenAPI spec version: v1
 */
import { z as zod } from 'zod';

export const AccountSwitchRequest = zod.strictObject({
    account_id: zod.number(),
});

export type AccountSwitchRequest = zod.input<typeof AccountSwitchRequest>;
export type AccountSwitchRequestOutput = zod.output<
    typeof AccountSwitchRequest
>;
